// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2hhXQ","rootCenter":"LoadMoreObserver_rootCenter__2cBLC","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2nId9"};